import ThankYouPage from '../../components/Pages/ThankYouPage/ThankYouPage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function ThankYouPageWrapper() {
  const shouldBePage = pages.thankYou;
  const conditionTypes = {
    page: true,
  };

  return (
    <PageWrapper
      pageToLoad={<ThankYouPage />}
      shouldBePage={shouldBePage}
      conditions={conditionTypes}
    />
  );
}
